module.exports = ".knowledge-dropdown{width:100%}";